<template>
  <div admin>
    <app-header />
    <router-view/>
    <app-footer />
  </div>
</template>

<style lang="less">
  @import '../../less/common';
  @import '../../less/admin';
</style>

<script>
import AppHeader from './common/AppHeader.vue';
import AppFooter from './common/AppFooter.vue';

export default {
  components: { AppHeader, AppFooter },
  mounted() {
    document.title = this.asset('name');
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin/template.vue